var map = {
	"./en-au": 840,
	"./en-au.js": 840,
	"./en-ca": 841,
	"./en-ca.js": 841,
	"./en-gb": 842,
	"./en-gb.js": 842,
	"./en-ie": 843,
	"./en-ie.js": 843,
	"./en-il": 844,
	"./en-il.js": 844,
	"./en-in": 845,
	"./en-in.js": 845,
	"./en-nz": 846,
	"./en-nz.js": 846,
	"./en-sg": 847,
	"./en-sg.js": 847
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 839;



//////////////////
// WEBPACK FOOTER
// ./~/moment/locale en
// module id = 839
// module chunks = 0